// TermsOfService.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './LegalPages.css';
import logo from '../images/logo.png';

function TermsOfService() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user'));
  const user_id = user?.user_id;

  return (
    <div className="legal-page light-theme">
      {/* Navigation */}
      <nav className="legal-navbar">
        <div className="legal-nav-container">
          <button
            className="legal-brand"
            onClick={() => navigate(user_id ? '/home' : '/')}
          >
            <img src={logo} alt='Marshall AI Logo' className='legal-logo' />
            <span>Marshall AI</span>
          </button>
          <button
            className="legal-back-btn"
            onClick={() => navigate(-1)}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Back
          </button>
        </div>
      </nav>

      {/* Main Content */}
      <div className="legal-container">
        <div className="legal-content">
          <h1 className="legal-title">Terms of Service</h1>
          <p className="legal-last-updated">Last Updated: April 12, 2026</p>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using Marshall AI ("Service"), you agree to be bound by these Terms of Service 
              ("Terms"). If you do not agree to these Terms, please do not use our Service.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Description of Service</h2>
            <p>
              Marshall AI provides an AI-powered chat assistant that helps users with various tasks including 
              but not limited to:
            </p>
            <ul>
              <li>Answering questions and providing information</li>
              <li>Writing assistance and content generation</li>
              <li>Code writing, debugging, and explanation</li>
              <li>Image analysis and description</li>
              <li>General conversation and assistance</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. User Accounts</h2>
            <h3>3.1 Account Creation</h3>
            <p>To use certain features, you must create an account. You agree to:</p>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Promptly update any changes to your information</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>

            <h3>3.2 Account Termination</h3>
            <p>
              We reserve the right to suspend or terminate your account at our discretion, 
              without prior notice, for violations of these Terms or any unlawful activity.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Acceptable Use Policy</h2>
            <p>You agree not to use the Service to:</p>
            <ul>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe upon intellectual property rights</li>
              <li>Generate harmful, abusive, or harassing content</li>
              <li>Distribute malware, viruses, or harmful code</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the Service or its infrastructure</li>
              <li>Use automated systems (bots, scrapers) without permission</li>
              <li>Impersonate others or provide false information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Content and Intellectual Property</h2>
            <h3>5.1 Your Content</h3>
            <p>
              You retain ownership of the content you submit to the Service. By submitting content, 
              you grant us a worldwide, non-exclusive, royalty-free license to use, process, and store 
              your content for the purpose of providing and improving the Service.
            </p>

            <h3>5.2 Our Content</h3>
            <p>
              The Service, including its design, code, graphics, and AI models, is protected by 
              intellectual property laws. You may not copy, modify, or distribute our content 
              without express permission.
            </p>

            <h3>5.3 AI-Generated Content</h3>
            <p>
              Content generated by our AI is provided "as is" without warranties. You are responsible 
              for reviewing and validating AI-generated content before use.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Credits and Usage Limits</h2>
            <p>
              Free accounts are subject to daily usage limits. We reserve the right to modify credit 
              allocations and introduce paid tiers at our discretion. Unused credits do not roll over 
              to the next day.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Third-Party Services</h2>
            <p>
              Our Service may integrate with third-party services (e.g., Google OAuth). We are not 
              responsible for the practices or content of these third-party services. Your use of 
              such services is subject to their respective terms and policies.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Disclaimer of Warranties</h2>
            <p>
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
              EITHER EXPRESS OR IMPLIED. WE DO NOT GUARANTEE THAT:
            </p>
            <ul>
              <li>The Service will be uninterrupted or error-free</li>
              <li>AI-generated content will be accurate or complete</li>
              <li>Any errors will be corrected</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, MARSHALL AI SHALL NOT BE LIABLE FOR ANY 
              INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM 
              YOUR USE OF THE SERVICE.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless Marshall AI and its affiliates from any claims, 
              damages, or expenses arising from your use of the Service or violation of these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Modifications to Terms</h2>
            <p>
              We may modify these Terms at any time. We will notify users of significant changes 
              via email or through the Service. Continued use after changes constitutes acceptance 
              of the modified Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of 
              the United States, without regard to conflict of law principles.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Contact Information</h2>
            <p>For questions about these Terms, contact us at:</p>
            <ul>
              <li><strong>Email:</strong> c84289798@gmail.com</li>
              <li><strong>Subject Line:</strong> Terms of Service Inquiry</li>

            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;